import { useState } from "react";
import { INIT_FILTER_FIELDS } from "../constants";

const useFilters = ({
    isCampusCoordinator
}) => {
    //#region States
    const [filters, setFilters] = useState({ ...INIT_FILTER_FIELDS });
    const [appliedFilters, setAppliedFilters] = useState({
        ...INIT_FILTER_FIELDS,
        page: 0
    });
    //#endregion
    //#region Functions
    function applyFilters(newValues) {
        setAppliedFilters(prev  => ({ ...prev, ...newValues }));
    }
    function applyAllFilters(extraValues) {
        setAppliedFilters({
            ...filters,
            ...extraValues
        });
    }
    function filtersHaveBeenApplied() {
        const {
            campusId,
            // Es necesario verificar si se decide activar alguno de estos filtros
            //spaceTypeId, activityId, studentId,
            date
        } = filters;
        return Boolean(
            campusId !== appliedFilters.campusId ||
            date !== appliedFilters.date
        );
    }
    function changeFilter(key, value) {
        setFilters(prev => ({
            ...prev,
            [key]: value
        }));
    }
    function clearFilters() {
        let clearedFilters = {};
        if (isCampusCoordinator) {
            const { campusId, ...restClearedFilters } = INIT_FILTER_FIELDS;
            clearedFilters = {
                ...filters,
                ...restClearedFilters
            };
        }
        else clearedFilters = { ...INIT_FILTER_FIELDS }
        setFilters({ ...clearedFilters });
    }
    function filtersAreCompleted() {
        return filters.campusId > 0 && filters.date > -1;
            // Nota: Habilitar cuando se integren estos filtros
            //&& activityId > 0 && spaceTypeId.length > 0 && studentId.length > 0
    }
    function checkClearedFilterFields() {
        const { campusId, date } = filters;
        return (
            campusId === 0 && date === -1
            // Nota: Habilitar cuando se integren estos filtros
            //&& activityId === 0 && spaceTypeId.length === 0 && studentId.length === 0
        );
    }
    //#endregion
    return {
        value: filters,
        change: changeFilter,
        clear: clearFilters,
        areCompleted: filtersAreCompleted,
        isCleared: checkClearedFilterFields,
        haveBeenApplied: filtersHaveBeenApplied,
        appliedFilters: {
            value: appliedFilters,
            apply: applyFilters,
            applyAllFilters
        }
    };
}

export default useFilters;